/**
 * The values of a sections tab that changed between two answers of `tab-content` (after an action, say): the
 * fields to light up for a moment, keyed `<section>:<field>`. A field that appears (filled since) counts; the
 * first answer of a tab changes nothing.
 */

type FieldLike = { field_name: string; value?: unknown; related_value?: unknown };
type SectionLike = { name: string; fields?: FieldLike[] | null };

export function fieldKey(section: string, field: string): string {
    return `${section}:${field}`;
}

function values(sections: SectionLike[] | null | undefined): Map<string, string> {
    const map = new Map<string, string>();
    (sections ?? []).forEach(section => (section.fields ?? []).forEach(field => map.set(fieldKey(section.name, field.field_name), JSON.stringify([field.value ?? null, field.related_value ?? null]))));
    return map;
}

export function changedFieldKeys(previous: SectionLike[] | null | undefined, next: SectionLike[] | null | undefined): Set<string> {
    if (!previous) return new Set();
    const before = values(previous);
    const changed = new Set<string>();
    values(next).forEach((value, key) => {
        if (before.get(key) !== value) changed.add(key);
    });
    return changed;
}
